<div class="min-h-screen bg-slate-50 font-inter text-slate-950">
  <div class="mx-auto flex min-h-screen max-w-3xl flex-col justify-center gap-8 px-6 py-12">
    <img
      src="assets/brand/logo.svg"
      width="48"
      height="48"
      alt="FormOps logo"
      class="h-12 w-12 rounded-2xl bg-white p-1.5 shadow-lg shadow-black/10" />

    <div class="flex flex-col gap-2">
      <h1 class="text-2xl font-semibold text-slate-950">Choose a workspace</h1>
      <p class="text-body1 text-slate-600">
        Select the workspace you want to open.
      </p>
    </div>

    @if (workspacesState.loading()) {
      <p class="text-sm text-slate-500">Loading workspaces…</p>
    } @else {
      <div class="grid gap-5">
        @for (group of workspaceGroups(); track group.companyId) {
          <div class="grid gap-3">
            <p class="text-xs font-medium uppercase tracking-wide text-slate-500">
              {{ group.companyName }}
            </p>
            @for (workspace of group.workspaces; track workspace.id) {
              <button
                type="button"
                class="w-full cursor-pointer rounded-xl border border-slate-200 bg-transparent px-4 py-3 text-left transition hover:border-slate-300 disabled:cursor-not-allowed disabled:opacity-60"
                [disabled]="switchingWorkspaceId() !== null"
                (click)="onWorkspaceSelected(workspace)">
                <app-workspace-card [workspace]="workspace" />
              </button>
            }
          </div>
        }
      </div>
    }

    <a routerLink="/login" class="text-sm font-medium text-primary-600 hover:text-primary-700">
      Sign in with a different account
    </a>
  </div>
</div>
